import AppleFavicon57 from '@/assets/favicons/apple-touch-icon-57x57.png';
import AppleFavicon60 from '@/assets/favicons/apple-touch-icon-60x60.png';
import AppleFavicon72 from '@/assets/favicons/apple-touch-icon-72x72.png';
import AppleFavicon76 from '@/assets/favicons/apple-touch-icon-76x76.png';
import AppleFavicon114 from '@/assets/favicons/apple-touch-icon-114x114.png';
import AppleFavicon120 from '@/assets/favicons/apple-touch-icon-120x120.png';
import AppleFavicon144 from '@/assets/favicons/apple-touch-icon-144x144.png';
import AppleFavicon152 from '@/assets/favicons/apple-touch-icon-152x152.png';
import AppleFavicon180 from '@/assets/favicons/apple-touch-icon-180x180.png';
import Favicon16 from '@/assets/favicons/favicon-16x16.png';
import Favicon32 from '@/assets/favicons/favicon-32x32.png';
import Favicon96 from '@/assets/favicons/favicon-96x96.png';
import Favicon194 from '@/assets/favicons/favicon-194x194.png';
import Favicon192 from '@/assets/favicons/android-chrome-192x192.png';

const Favicons = [
  { rel: 'apple-touch-icon', sizes: '57x57', href: AppleFavicon57 },
  { rel: 'apple-touch-icon', sizes: '60x60', href: AppleFavicon60 },
  { rel: 'apple-touch-icon', sizes: '72x72', href: AppleFavicon72 },
  { rel: 'apple-touch-icon', sizes: '76x76', href: AppleFavicon76 },
  { rel: 'apple-touch-icon', sizes: '114x114', href: AppleFavicon114 },
  { rel: 'apple-touch-icon', sizes: '120x120', href: AppleFavicon120 },
  { rel: 'apple-touch-icon', sizes: '144x144', href: AppleFavicon144 },
  { rel: 'apple-touch-icon', sizes: '152x152', href: AppleFavicon152 },
  { rel: 'apple-touch-icon', sizes: '180x180', href: AppleFavicon180 },

  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: Favicon16,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: Favicon32,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '96x96',
    href: Favicon96,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '192x192',
    href: Favicon192,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '194x194',
    href: Favicon194,
  },
];

export default Favicons;
